module.exports = __webpack_public_path__ + "assets/img/s1.32b51f7f.png";